import { render, staticRenderFns } from "./CertificateTypeBadges.vue?vue&type=template&id=1615d860&scoped=true"
import script from "./CertificateTypeBadges.vue?vue&type=script&lang=js"
export * from "./CertificateTypeBadges.vue?vue&type=script&lang=js"
import style0 from "./CertificateTypeBadges.vue?vue&type=style&index=0&id=1615d860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1615d860",
  null
  
)

export default component.exports